/*
 * Filename: d:\projects\AutoFiFront\src\Theme\FilterIconReset.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 2:53:17 pm
 * Author: Jonathan MAZAT
 * 
 * Copyright (c) 2023 Autobuy SAS
 */
import styled from "styled-components";

const FilterIconReset = styled.div.attrs(props => ({
    bgColor: props.bgColor,
}))`
cursor: pointer;
color: ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
`;

export default FilterIconReset;
